import { GlobalLoader } from "./globalLoader"

export const GlobalCfeLoader = ({type, color}) => {
    return (
        <GlobalLoader type = {type} color = {color} />
    )
}